'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSocketMiddleware = undefined;

var _createPrepareActionForServerFn = require('./createPrepareActionForServerFn');

var _currentUserSelector = require('../../../user/currentUserSelector');

var _currentUserConstants = require('../../../user/currentUserConstants');

var _authConstants = require('../../../auth/authConstants');

var _socketConstants = require('../socketConstants');

var _electronConstants = require('../../../../common/electron/electronConstants');

// Constants
// Util
var createSocketMiddleware = exports.createSocketMiddleware = function createSocketMiddleware(socketManager) {
    return function (store) {
        var prepareActionForServer = (0, _createPrepareActionForServerFn.createPrepareActionForServerFn)(store);

        return function (next) {
            return function (action) {
                var newState = next(action);

                var isGuest = (0, _currentUserSelector.isGuestSelector)(store.getState());
                if (isGuest && action.type !== _authConstants.LOGOUT) return newState;

                if (action.sync) {
                    var syncAction = prepareActionForServer(action);
                    socketManager.emitAction(syncAction);
                }

                switch (action.type) {
                    case _currentUserConstants.CURRENT_USER_SET:
                        socketManager.connectSocket(action.user._id);
                        break;
                    case _socketConstants.CHANNELS_UPDATED:
                        socketManager.updateChannels(action);
                        break;
                    case _authConstants.LOGOUT:
                        socketManager.disconnectSocket();
                        break;
                    case _electronConstants.ELECTRON_APP_SLEEP:
                        socketManager.disconnectSocket();
                        break;
                    case _electronConstants.ELECTRON_APP_WAKE:
                        socketManager.connectSocket();
                        break;
                    default:
                        break;
                }

                return newState;
            };
        };
    };
};

// Data selectors


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/middleware/createSocketMiddleware.js
// module id = 2141
// module chunks = 0